export default __webpack_public_path__ + "static/media/CardTitleRelaunch.cd52a781.svg";